import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react'
import Slider from 'react-slick'
import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component'
import axios from 'axios'
import { useMediaQuery } from 'react-responsive'
import Layout from '../Layout'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { Link, useHistory } from 'react-router-dom'
import './home.css'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import moment from 'moment'
import { getAdsImage, handleRedirectInternal } from '../../../Product/common/components'
import AlertContext from '../../../Product/context/alert/alertContext'
import UserContext from '../../../Product/context/user/userContext'
import { useLocation } from 'react-router-dom'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import LotsGridAuction from '../../../Component/ProductCard/lotsAuction'
import { Button } from '@material-ui/core'
import Loaders from '../../../Product/components/molecules/Loaders'
import CategoryModal from '../../../Component/Categories/CategoryModal'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core/styles'
import LotProduct from '../../../Component/ProductCard/lotProduct'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import Reviews from './review'
import { useFormik } from 'formik'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import WebpImage from '../../../Component/WebpImage'
import buyBestMobBannerOne from '../../../assets/images/buyBestBanner1.png'
import buyBestMobBannerTwo from '../../../assets/images/buyBestBanner2.png'
import buyBestMobBannerThree from '../../../assets/images/buyBestBanner3.png'
import buyBestMobBannerFour from '../../../assets/images/buyBestBanner4.png'
import buyBestMobBannerFive from '../../../assets/images/buyBestBanner5.png'

const Home = (props) => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const productContext = useContext(ProductContext)
    const alertContext = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const { static_page, getStaticPage } = userContext
    const {
        search_allproducts,
        search_allauctions,
        getAllSearchAuctions,
        productLocalState,
        getAllSearchItems,
        getAllSearchProducts,
        get_all_cat,
        getallitemcount,
        get_all_count,
        setState: setProductState,
    } = productContext
    const authContext = useContext(AuthContext)
    const { isAuthenticated, user } = authContext
    const { setAlert } = alertContext
    const history = useHistory()
    const [lotsPageLoading, setlotsPageLoading] = useState(true)
    const [galleryPageLoading, setgalleryPageLoading] = useState(true)
    const [upcomingHomeLoading, setupcomingHomeLoading] = useState(true)
    const [closedHomeLoading, setclosedHomeLoading] = useState(true)
    const [activeHomeLoading, setactiveHomeLoading] = useState(true)
    const [activereverseLoading, setactiveReverseLoading] = useState(true)
    const [viewlots, setViewLots] = useState([])
    const [viewProduct, setViewProduct] = useState([])
    const [endingProduct, setEndingProduct] = useState([])
    const [buyNowProduct, setBuyNowProduct] = useState([])
    const [activeAuctions, setActiveAuctions] = useState([])
    const [activeAuctions1, setActiveAuctions1] = useState([])
    const [reverseAuctions, setReverseAuctions] = useState([])
    const [activeHome, setActiveHome] = useState([])
    const [upcomingHome, setUpcomingHome] = useState([])
    const sessionTimeOutRef = useRef(null)
    const [viewClosedAuction, setViewClosedAuction] = useState([])
    const [cancelRequest, setCancelRequest] = useState(undefined)
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [selectedDate1, setSelectedDate1] = useState(new Date())
    const cancelToken = axios.CancelToken.source()
    const [open2, setOpen2] = useState(false)
    const [lotof, setLotof] = useState(0)
    const [ProductLocation, setProductLocation] = useState([])
    const [filterValues, setFilterValues] = useState([])
    const [product_item, setProductItem] = useState([])
    const [Loading, setLoading] = useState(false)
    const [filterDate, setFilterDate] = useState(null)
    const [filterDate2, setFilterDate2] = useState(null)
    const [filterDateList, setFilterDateList] = useState([])
    const [filterDateList2, setFilterDateList2] = useState([])
    const [catg] = useState(new URLSearchParams(window.location.search.substring(1)).get('cat'))
    const [rat] = useState(new URLSearchParams(window.location.search.substring(1)).get('rat'))
    const [est] = useState(new URLSearchParams(window.location.search.substring(1)).get('est'))
    const [view] = useState(new URLSearchParams(window.location.search.substring(1)).get('view'))
    const [sort] = useState(new URLSearchParams(window.location.search.substring(1)).get('sort'))
    const [slimit] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('slimit'),
    )
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const [auctionSearch, setAuctionsearch] = useState({
        page: 1,
        sh_limit: '20',
        orderby: isVarifiedGfTheme
            ? '9'
            : isTabletOrMobile && global?.storeConfigration?.auction_close_soon_mobile?.value
            ? global?.storeConfigration?.auction_close_soon_mobile?.value
            : global.storeConfigration?.auction_search_order?.value
            ? global.storeConfigration.auction_search_order.value
            : '2',
        searchbar: '',
        between_date_io: undefined,
        between_date_io_new: undefined,
        filter_from_first: 0,
        filter_from_second: 0,
        need_lot_count: 1,
        lot_images: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        auc_type: '2',
        auction_io: 1,
        auction_only: 1,
        retail: 1,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
    })
    const now = new Date()
    const [upcomingSearch, setUpcomingSearch] = useState({
        page: 1,
        sh_limit: '20',
        orderby: '9',
        searchbar: '',
        auction_io: 1,
        lot_images: 1,
        auc_type: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        type: '',
        from: 'upcomingHomeSearch',
        retail: 1,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
    })
    const [productSearch, setProductSearch] = useState({
        sh_limit: 20,
        from: 'buynow',
        page: 1,
        orderby: '1',
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
    })

    const getSearchBar = (searchbar) => {
        let where = ''
        if (searchbar) {
            const searchValue = searchbar.trim()
            if (
                global.storeConfigration?.show_warehouse_location?.value == 1 &&
                global.storeConfigration?.lot_sequence_order?.value == 1
            ) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.lot_sequence_order?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.show_warehouse_location?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            }
        }
        return where
    }

    const getWhere = (type, keys) => {
        let where = ' (p.auction=1 or p.buynow=1) and p.market_status="open" and p.qty > 0'
        if (type === 'search') {
            where += getSearchBar(keys)
        }
        if (type === 'location') {
            where += keys
        }
        return where
    }

    const formik = useFormik({
        initialValues: {
            orderby: '02',
            category: [],
            subcategory: [],
            closed_auction_list: 0,
            perlimit: isVarifiedGfTheme ? 4 : isBuyBestProject ? 8 : '50',
            no_pagination: isVarifiedGfTheme ? 1 : 0,
            page: 1,
            joinsdata: `a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
            }`,
            nobids: isVarifiedGfTheme ? 1 : 1,
            latestbid: isVarifiedGfTheme ? 0 : 1,
            latestbid_user: 1,
            lot_images: 1,
            userid: user?.id,
            getbidding: isVarifiedGfTheme ? 0 : 1,
            need_bid_increment: isVarifiedGfTheme ? 0 : 1,
            customwhere: params.get('q')
                ? getWhere('search', params.get('q'))
                : getWhere('search', ''),
            joins: user?.id
                ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                : ` inner join auctionlot as a on a.id=p.lotof `,
            location: [],
            toprice: 0,
            quality_rating: rat == null || rat == 1 || rat == '' ? [] : rat,
            from: 'homePageLotItems',
            from_id: 1,
            auction_io: 1,
            auction_city:
                productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
            size: [],
            get_city_state: 1,
            dont_show: global?.storeConfigration?.donot_show_categories?.value
                ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                : [],
            site_id: global?.storeDetails?.site_id,
        },
    })
    const mobileBuyImgSrc = [
        buyBestMobBannerOne,
        buyBestMobBannerTwo,
        buyBestMobBannerThree,
        buyBestMobBannerFour,
        buyBestMobBannerFive,
    ]
    const [lotSearch, setLotSearch] = useState({
        sh_limit: 20,
        from: 'auction_only',
        page: 1,
        orderby: '12',
        // most_viewed: 1,
        // viewers: 1,
        featured: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
    })

    useEffect(() => {
        setProductLocation(productLocalState.globalLocations)
    }, [productLocalState.globalLocations])

    useEffect(() => {
        if (get_all_cat.from == 'get_all_items_count') {
            if (get_all_cat.data.length > 0) {
                setFilterValues(get_all_cat.data.sort((a, b) => a.name.localeCompare(b.name)))
            }
        }
    }, [get_all_cat])

    useEffect(() => {
        if (get_all_count.from == 'get_total_items_count') {
            if (get_all_count.data.length > 0) {
                setProductItem(get_all_count.data)
            }
        }
    }, [get_all_count])

    useEffect(() => {
        const newCity =
            productLocalState?.globalLocation === 'All' ? [] : [productLocalState?.globalLocation]

        if (JSON.stringify(auctionSearch?.auction_city) !== JSON.stringify(newCity)) {
            setAuctionsearch({
                ...auctionSearch,
                auction_city: newCity,
            })
        }

        if (JSON.stringify(productSearch?.auction_city) !== JSON.stringify(newCity)) {
            setProductSearch({
                ...productSearch,
                auction_city: newCity,
            })
        }

        if (JSON.stringify(upcomingSearch?.auction_city) !== JSON.stringify(newCity)) {
            setUpcomingSearch({
                ...upcomingSearch,
                auction_city: newCity,
            })
        }
    }, [productLocalState.globalLocation])

    const handleDateChange = (date) => {
        if (date == 'all') {
            setFilterDate(null)
            setAuctionsearch({
                ...auctionSearch,
                between_date_io: undefined,
                between_date_io_new: undefined,
                filter_from_first: 0,
                filter_from_second: 1,
            })
        } else {
            setFilterDate(date)
            setAuctionsearch({
                ...auctionSearch,
                between_date_io: moment(date).format('YYYY-MM-DD'),
                between_date_io_new: undefined,
                filter_from_first: 0,
                filter_from_second: 1,
            })
            setSelectedDate(date)
        }
    }

    const handleDateChange1 = (date) => {
        if (date == 'all') {
            setFilterDate2(null)
            setAuctionsearch({
                ...auctionSearch,
                between_date_io: undefined,
                between_date_io_new: undefined,
                filter_from: 1,
                filter_from_first: 1,
                filter_from_second: 0,
            })
        } else {
            setFilterDate2(date)
            setAuctionsearch({
                ...auctionSearch,
                between_date_io: undefined,
                between_date_io_new: date,
                filter_from: 1,
                filter_from_first: 1,
                filter_from_second: 0,
            })
            setSelectedDate1(date)
        }
    }

    const handleCategory = (id) => {
        setOpen2(true)
        setLotof(id)
    }

    useEffect(() => {
        setgalleryPageLoading(true)
        getAllSearchItems(
            {
                ...formik.values,
                page: 1,
                joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                    user?.id
                        ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                        : ''
                }`,
                joins: user?.id
                    ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                    : ` inner join auctionlot as a on a.id=p.lotof `,
                category_based_order: isBuyBestProject ? 1 : undefined,
            },
            'homePageLotItems',
        )
        if (isVarifiedGfTheme) {
            getAllSearchItems(
                {
                    ...formik.values,
                    page: 1,
                    perlimit: isBuyBestProject ? 8 : 4,
                    joinsdata: `a.title as auctionTitle, a.date_closed as auction_date_closed, p.title,a.state as auction_state, a.city as auction_city,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,IFNULL(w.id,0) as watchlisted ,0 AS currentUserBidAmount,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                    joins: user?.id
                        ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 `
                        : ` `,
                    order_by: `order by p.wprice desc, p.bprice desc`,
                    orderby: 17,
                    customwhere: `p.market_status="open" and p.qty > 0`,
                    join_latest_auctionlot: 1,
                },
                'homePageEndingItems',
            )
        }
        // getAllSearchProducts(productSearch, 'galleryPage')
        if (!isVarifiedGfTheme) {
            getallitemcount({
                locations: productLocalState.globalLocations,
                site_id: global?.storeDetails?.site_id,
                from: 'get_total_items_count',
            })
        }
    }, [productSearch, isAuthenticated])

    useEffect(() => {
        if (search_allproducts.from === 'galleryPage') {
            setBuyNowProduct(search_allproducts.results.length ? search_allproducts.results : [])
            setgalleryPageLoading(false)
        }
        if (search_allproducts.from === 'lotsPage' && !isVarifiedGfTheme) {
            clearTimeout(sessionTimeOutRef.current)
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            if (lotSearch.most_viewed_feature && !search_allproducts.results.length) {
                setLotSearch({
                    ...lotSearch,
                    most_viewed: 1,
                    most_viewed_feature: 0,
                })
            } else {
                setlotsPageLoading(false)
            }
        }
        if (search_allproducts.from === 'homePageLotItems' && isVarifiedGfTheme) {
            clearTimeout(sessionTimeOutRef.current)
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            setlotsPageLoading(false)
        }
        if (search_allproducts.from === 'homePageEndingItems' && isVarifiedGfTheme) {
            clearTimeout(sessionTimeOutRef.current)
            setEndingProduct(search_allproducts.results.length ? search_allproducts.results : [])
            setlotsPageLoading(false)
        }
    }, [search_allproducts])
    useEffect(() => {
        setlotsPageLoading(true)
        if (cancelRequest) {
            cancelRequest.cancel()
        }

        setCancelRequest(cancelToken)
        if (!isVarifiedGfTheme) {
            getAllSearchProducts(lotSearch, 'lotsPage')
        }
    }, [lotSearch, isAuthenticated])

    const redirectAuction = useCallback((link) => {
        handleRedirectInternal(history, link)
    }, [])

    useEffect(() => {
        if (!isBuyBestProject) {
            setupcomingHomeLoading(true)
            getAllSearchAuctions(upcomingSearch, 'upcomingHomeSearch')
        }
    }, [upcomingSearch])

    useEffect(() => {
        setactiveHomeLoading(true)
        if (productLocalState.globalLocation == 'All') {
            if (!auctionSearch.filter_from_first) {
                getAllSearchAuctions(auctionSearch, 'activeHome')
            }
            if (!auctionSearch.filter_from_second && !isVarifiedGfTheme) {
                getAllSearchAuctions(auctionSearch, 'activeHome1')
            }
        } else {
            getAllSearchAuctions(auctionSearch, 'activeHome')
        }

        if (global?.storeConfigration?.buy_now_home_changes?.value) {
            var body_request = auctionSearch
            body_request.is_auction = 0
            body_request.is_buynow = 1
            getAllSearchAuctions(body_request, 'activeHome_buynow')
        }

        if (global?.pluginConfiguration?.reverse_auction?.enable) {
            var body_request = auctionSearch
            body_request.auction_io_type = 1
            getAllSearchAuctions(body_request, 'reverse_auction')
        }
    }, [auctionSearch])

    useEffect(() => {
        if (search_allauctions.from === 'activeHome') {
            var activeAuctions = search_allauctions.results.length ? search_allauctions.results : []
            setActiveAuctions(
                activeAuctions.filter(
                    (data) => data.market_status == 'open' && data.remainingDay >= 0,
                ),
            )
            setactiveHomeLoading(false)
            if (params.get('dynamic') == 1) {
                if (search_allauctions.results.length)
                    history.push(
                        `/search/product-buyer-auction/${search_allauctions.results[0]?.id}?cat=&rat=&est=0`,
                    )
            }

            if (search_allauctions.auction_enddate_list.length > 0) {
                var unique_date_list = search_allauctions.auction_enddate_list
                    .map((item) => {
                        const obj = Object.assign({}, item)
                        obj.format_date = moment(item.date_closed).format('YYYY-MM-DD')
                        return obj
                    })
                    .filter(
                        (value, index, self) =>
                            self.map((x) => x.format_date).indexOf(value.format_date) == index,
                    )
                    .sort(function (a, b) {
                        return new Date(a.format_date) - new Date(b.format_date)
                    })
                setFilterDateList(unique_date_list)
            }
        }
        if (search_allauctions.from === 'activeHome1') {
            var activeAuctions1 = search_allauctions.results.length
                ? search_allauctions.results
                : []

            setActiveAuctions1(
                activeAuctions1.filter(
                    (data) => data.market_status == 'open' && data.remainingDay >= 0,
                ),
            )
            // setTimeout(() => {
            setactiveHomeLoading(false)
            // }, 1500)

            if (search_allauctions.auction_enddate_list.length > 0) {
                var unique_date_list = search_allauctions.auction_enddate_list
                    .map((item) => {
                        const obj = Object.assign({}, item)
                        obj.format_date = moment(item.date_closed).format('YYYY-MM-DD')
                        return obj
                    })
                    .filter(
                        (value, index, self) =>
                            self.map((x) => x.format_date).indexOf(value.format_date) == index,
                    )
                    .sort(function (a, b) {
                        return new Date(a.format_date) - new Date(b.format_date)
                    })
                setFilterDateList2(unique_date_list)
            }
        }
        if (search_allauctions.from === 'reverse_auction') {
            setReverseAuctions(search_allauctions.results.length ? search_allauctions.results : [])
            setactiveReverseLoading(false)
        }
        if (search_allauctions.from === 'closedHome') {
            setViewClosedAuction(
                search_allauctions.results.length ? search_allauctions.results : [],
            )
            setclosedHomeLoading(false)
        }
        if (search_allauctions.from == 'activeHome_buynow') {
            setActiveHome(search_allauctions.results.length ? search_allauctions.results : [])
        }
        if (search_allauctions.from == 'upcomingHomeSearch') {
            setUpcomingHome(search_allauctions.results.length ? search_allauctions.results : [])
            setupcomingHomeLoading(false)
        }
    }, [search_allauctions])

    const viewProductRef = useRef(viewProduct)
    const endingProductRef = useRef(endingProduct)
    const userRef = useRef(user)

    useEffect(() => {
        viewProductRef.current = viewProduct
        endingProductRef.current = endingProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
        messageHandler(
            message,
            endingProductRef.current,
            userRef.current,
            setAlert,
            setEndingProduct,
            type,
        )
    }

    const handleLocationChange = (locationValue) => {
        setLoading(true)
        localStorage.setItem('globalLocation', locationValue)
        setProductState({
            ...productLocalState,
            globalLocation: locationValue,
        })

        setTimeout(() => {
            setLoading(false)
            handleRedirectInternal(history, `auctions`)
        }, 1000)
    }

    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('watchlist', (data) => {
            handler(data, 'watchlist')
        })
        socket.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })

            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.on('watchlist', (data) => {
                handler(data, 'watchlist')
            })
            socket.on('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })
        }
    }, [])

    useEffect(() => {
        if (global?.storeConfigration?.liq_home_page_banner_changes?.value == 1) {
            getStaticPage(
                {
                    page_id: 'home_banner_text',
                },
                1,
            )
        }
        localStorage.setItem('routeTo', '')
    }, [])

    const settings = {
        dots: true,
        fade: isBuyBestProject ? true : false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        lazyLoad: 'ondemand',
    }

    const settings1 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    }

    const settings2 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings3 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings4 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings5 = {
        dots: false,
        fade: false,
        arrows: isBuyBestProject ? true : false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        nav: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                    arrows: false,
                },
            },
            {
                breakpoint: 1720,
                settings: {
                    slidesToShow: 4,
                    arrows: false,
                },
            },
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                },
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                },
            },
        ],
    }
    const settings6 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        nav: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1720,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    }
    const isMobile = useMediaQuery({
        query: '(max-width: 767px)',
    })
    const isSmallMobile = useMediaQuery({
        query: '(max-width: 530px)',
    })

    const [homeAds, setHomeAds] = useState({
        deskHomeTop: '',
        deskHomeMid: '',
        mobHomeTop: '',
        mobHomeMid: '',
        deskHomeBottom: '',
        mobHomeBottom: '',
    })

    const [activeHomeAdsIndex, setActiveHomeAdsIndex] = useState({
        deskHomeTop: 0,
        deskHomeMid: 0,
        mobHomeTop: 0,
        mobHomeMid: 0,
        deskHomeBottom: 0,
        mobHomeBottom: 0,
    })

    function updateRandomIndex(array) {
        const randomIndex = Math.floor(Math.random() * array.length)
        return randomIndex
    }

    useEffect(() => {
        setHomeAds((prevAucAds) => ({
            deskHomeTop: getAdsImage(1, 1, 1),
            deskHomeMid: getAdsImage(1, 1, 2),
            mobHomeTop: getAdsImage(2, 1, 1),
            mobHomeMid: getAdsImage(2, 1, 2),
            deskHomeBottom: getAdsImage(1, 1, 5),
            mobHomeBottom: getAdsImage(2, 1, 5),
        }))
    }, [])

    useEffect(() => {
        setActiveHomeAdsIndex((prevActiveIndex) => ({
            deskHomeTop: updateRandomIndex(homeAds?.deskHomeTop),
            deskHomeMid: updateRandomIndex(homeAds?.deskHomeMid),
            mobHomeTop: updateRandomIndex(homeAds?.mobHomeTop),
            mobHomeMid: updateRandomIndex(homeAds?.mobHomeMid),
            deskHomeBottom: updateRandomIndex(homeAds?.deskHomeBottom),
            mobHomeBottom: updateRandomIndex(homeAds?.mobHomeBottom),
        }))
    }, [homeAds])

    const handleViewAllClick = (e) => {
        e.preventDefault()
        history.push(`/search?q=&est=0&rat=&cat=&view=0&sort=02&slimit=50&title=Flash Deals`)
    }

    const handleEndingViewAllClick = (id, title) => {
        let detailsUrl = `search?q=&cat=&est=0&rat=&view=0&sort=17&slimit=50&lotof=${id}&title=${encodeURIComponent(
            title,
        )}`
        history.push(detailsUrl)
    }

    const [showAll, setShowAll] = useState(false)

    const filteredSortedAuctions = activeAuctions
        ?.filter((ele) => new Date(ele.date_closed) >= now)
        ?.sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))

    const displayedAuctions = showAll
        ? filteredSortedAuctions
        : isBuyBestProject
        ? filteredSortedAuctions
        : filteredSortedAuctions?.slice(0, 3)

    const banners = useMemo(
        () =>
            global?.multipleBannersFields?.map((b) => ({
                ...b,
                fieldsParsed: b.fields ? JSON.parse(b.fields) : {},
            })) || [],
        [global?.multipleBannersFields],
    )
    const mobileBanners = useMemo(
        () =>
            global?.multipleMobileBannersFields?.map((b) => ({
                ...b,
                fieldsParsed: b.fields ? JSON.parse(b.fields) : {},
            })) || [],
        [global?.multipleMobileBannersFields],
    )
    useEffect(() => {
        if (banners.length > 0) {
            const firstImage = banners[0]?.image_name
            if (firstImage) {
                const imageUrl = `${process.env.REACT_APP_AUCTION_IMAGE_URL}/${firstImage}`
                const link = document.createElement('link')
                link.rel = 'preload'
                link.as = 'image'
                link.href = imageUrl
                link.fetchPriority = 'high'
                document.head.appendChild(link)
                return () => {
                    document.head.removeChild(link)
                }
            }
        }
    }, [banners])

    const videoRef = useRef(null)
    const video2Ref = useRef(null)

    const [showOverlay, setShowOverlay] = useState(true)
    const [show2Overlay, setShow2Overlay] = useState(true)
    const [isPlaying, setIsPlaying] = useState(false)
    const [is2Playing, setIs2Playing] = useState(false)

    const handlePlayClick = () => videoRef.current?.play()
    const handlePlay2Click = () => video2Ref.current?.play()

    useEffect(() => {
        const video = videoRef.current
        const video2 = video2Ref.current

        if (!video || !video2) return

        // VIDEO 1
        const onPlay = () => {
            setShowOverlay(false)
            setIsPlaying(true)
        }
        const onPause = () => {
            setShowOverlay(true)
            setIsPlaying(false)
        }
        const onEnded = () => {
            setShowOverlay(true)
            setIsPlaying(false)
        }

        // VIDEO 2
        const onPlay2 = () => {
            setShow2Overlay(false)
            setIs2Playing(true)
        }
        const onPause2 = () => {
            setShow2Overlay(true)
            setIs2Playing(false)
        }
        const onEnded2 = () => {
            setShow2Overlay(true)
            setIs2Playing(false)
        }

        // Attach
        video.addEventListener('play', onPlay)
        video.addEventListener('pause', onPause)
        video.addEventListener('ended', onEnded)

        video2.addEventListener('play', onPlay2)
        video2.addEventListener('pause', onPause2)
        video2.addEventListener('ended', onEnded2)

        return () => {
            video.removeEventListener('play', onPlay)
            video.removeEventListener('pause', onPause)
            video.removeEventListener('ended', onEnded)

            video2.removeEventListener('play', onPlay2)
            video2.removeEventListener('pause', onPause2)
            video2.removeEventListener('ended', onEnded2)
        }
    }, [])

    const groupsOfFour = endingProduct.reduce((acc, item, index) => {
        if (index % 4 === 0) {
            acc.push(endingProduct.slice(index, index + 4))
        }
        return acc
    }, [])

    return (
        <>
            <SEOTAG page="Home" />
            <Layout props={props}>
                <div className="home loa-home-wrapper">
                    {isSmallMobile ? (
                        <>
                            <div className="siteBanner multiple">
                                <Slider {...settings}>
                                    {mobileBanners?.map((img, index) => {
                                        const imgsrc = `${process.env.REACT_APP_AUCTION_IMAGE_URL}/${img?.image_name}`
                                        return (
                                            <div className="banner-item" key={index}>
                                                <WebpImage
                                                    src={imgsrc}
                                                    alt="Banner"
                                                    width={500}
                                                    height={170}
                                                />
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        </>
                    ) : (
                        <>
                            {' '}
                            {global?.storeConfigration?.liq_home_page_banner_changes?.value == 1 ? (
                                <div className="siteBanner multiple">
                                    {static_page.content && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(static_page.content),
                                            }}
                                        ></div>
                                    )}
                                </div>
                            ) : global.multipleBannersFields.length ? (
                                <div
                                    className={`${
                                        isBuyBestProject && isSmallMobile ? '' : 'customContainer'
                                    } position-relative homeBanerContainer`}
                                >
                                    {isVarifiedGfTheme &&
                                        !isBargainsProject &&
                                        !isBuyBestProject && (
                                            <>
                                                <div className="bannerLabel">
                                                    <h4
                                                        onClick={() =>
                                                            history.push('/how_it_works')
                                                        }
                                                    >
                                                        New to Retail Rush? <span>Learn More</span>
                                                    </h4>
                                                </div>
                                            </>
                                        )}
                                    <div
                                        className="siteBanner multiple"
                                        style={{
                                            'margin-top': '-5px',
                                        }}
                                    >
                                        <Slider {...settings}>
                                            {banners.map((data, index) => {
                                                const parsedFields = data.fields
                                                    ? JSON.parse(data.fields)
                                                    : {}
                                                const imgsrc = `${process.env.REACT_APP_AUCTION_IMAGE_URL}/${data?.image_name}`
                                                const { title, description, btn_text } =
                                                    parsedFields
                                                const hasButton = Boolean(btn_text?.length)
                                                const firstAuction = activeAuctions[0]
                                                return (
                                                    <div className="banner-item" key={index}>
                                                        <WebpImage
                                                            src={imgsrc}
                                                            alt="Banner"
                                                            width={1280}
                                                            height={262}
                                                        />
                                                        {!isVarifiedGfTheme && (
                                                            <div className="bannerContent">
                                                                {title && <h2>{title}</h2>}
                                                                {description && (
                                                                    <p className="pb-4">
                                                                        {description}
                                                                    </p>
                                                                )}
                                                                <div className="banner-btns-wrap">
                                                                    {hasButton && (
                                                                        <PrimaryButton
                                                                            label={btn_text}
                                                                            type="button"
                                                                            disabled={Loading}
                                                                            onClick={() =>
                                                                                handleLocationChange(
                                                                                    productLocalState
                                                                                        .globalLocations[0],
                                                                                )
                                                                            }
                                                                        />
                                                                    )}

                                                                    {/* {JSON.parse(
                                                                    data.fields
                                                                        ? data.fields
                                                                        : '{}',
                                                                ).btn_text?.length > 0 && (
                                                                    <PrimaryButton
                                                                        label={
                                                                            JSON.parse(
                                                                                data.fields
                                                                                    ? data.fields
                                                                                    : '{}',
                                                                            ).btn_text
                                                                        }
                                                                        type="button"
                                                                        disabled={Loading}
                                                                        onClick={() =>
                                                                            handleLocationChange(
                                                                                productLocalState
                                                                                    .globalLocations[0],
                                                                            )
                                                                        }
                                                                    />
                                                                )} */}
                                                                    {!isAuthenticated && (
                                                                        <SecondaryButton
                                                                            label="Register Now"
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'sign-up',
                                                                                )
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {activeAuctions.length > 0 &&
                                                            !isVarifiedGfTheme &&
                                                            firstAuction && (
                                                                <div className="new-auction">
                                                                    New Auctions on{' '}
                                                                    {moment(
                                                                        activeAuctions[0]
                                                                            .date_added,
                                                                    ).format('dddd')}{' '}
                                                                    {moment(
                                                                        activeAuctions[0]
                                                                            .date_added,
                                                                    ).format(
                                                                        'MMMM Do YYYY, h:mm A',
                                                                    )}{' '}
                                                                    <Link
                                                                        to={`/search/product-buyer-auction/${activeAuctions[0].id}?cat=&rat=&est=0`}
                                                                    >
                                                                        View Now
                                                                    </Link>
                                                                </div>
                                                            )}
                                                    </div>
                                                )
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            ) : (
                                <div className="siteBanner">
                                    <LazyLoadImage
                                        src={
                                            global?.storeDetails?.bannerValue ||
                                            '/images/default-banner.jpg'
                                        }
                                        alt={`${global?.storeDetails?.name || 'Store'} banner`}
                                        effect="blur"
                                        height="100%"
                                        width="100%"
                                    />
                                    {global?.storeDetails?.description && (
                                        <div className="bannerContent">
                                            <h2>{global?.storeDetails?.description}</h2>
                                            <PrimaryButton
                                                label="Explore Now"
                                                disabled={Loading}
                                                onClick={() =>
                                                    handleLocationChange(
                                                        productLocalState.globalLocations[0],
                                                    )
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}

                    {isBuyBestProject && (
                        <div className="customContainer auctionListCnt">
                            {lotsPageLoading ? (
                                <Loaders
                                    name="product_grid_view"
                                    isLoading={lotsPageLoading}
                                    loop={4}
                                />
                            ) : endingProduct.length > 0 ? (
                                <div className="search-wrapper">
                                    <h2
                                        className="auctionListTitle text-capitalize"
                                        style={{ 'text-transform': 'capitalize' }}
                                    >
                                        {endingProduct[0].auction_city},{' '}
                                        <span className="text-uppercase">
                                            {isBuyBestProject
                                                ? 'VA'
                                                : endingProduct[0].auction_state.substring(0, 2)}
                                        </span>{' '}
                                        Auctions Closing Soon
                                    </h2>
                                    <>
                                        <div
                                            onClick={() => {
                                                handleEndingViewAllClick(
                                                    endingProduct[0].lotof,
                                                    endingProduct[0].auctionTitle,
                                                )
                                            }}
                                            className="viewAll"
                                        >
                                            View All
                                        </div>
                                        <div className="gridContainer liquidationAuctions featuredLots">
                                            {isSmallMobile ? (
                                                <Slider {...settings5}>
                                                    {groupsOfFour.map((group, index) => (
                                                        <LazyLoadComponent key={group?.id || index}>
                                                            <div
                                                                className={
                                                                    'liquidationBuyCard BuyBestMultiLotCard'
                                                                }
                                                                key={`gl-${index}`}
                                                            >
                                                                {group.map((item, j) => (
                                                                    <>
                                                                        <LotProduct
                                                                            data={item}
                                                                            lotImages={
                                                                                item?.lotImages
                                                                            }
                                                                            link={`/gallery/product-view/${item?.id}`}
                                                                            handleClick={() =>
                                                                                redirectAuction(
                                                                                    `search/product-buyer-auction/${item.id}?cat=&rat=&est=0`,
                                                                                )
                                                                            }
                                                                            timerTheme={
                                                                                props.timerTheme
                                                                            }
                                                                            type={props.type || ''}
                                                                            cardTheme={
                                                                                props.cardTheme
                                                                            }
                                                                            noTimer={props.noTimer}
                                                                            getAllProducts={
                                                                                getAllSearchProducts
                                                                            }
                                                                            setViewProduct={
                                                                                setEndingProduct
                                                                            }
                                                                            viewProduct={
                                                                                endingProduct
                                                                            }
                                                                            audio={props.audio}
                                                                            productViewLink={`/product/${item?.id}?cat=`}
                                                                            bidStatus="true"
                                                                            fromComponent="home"
                                                                            timerIcon={true}
                                                                            card_theme="lotsauction"
                                                                            noBuyNow={false}
                                                                            flashCard={false}
                                                                            endingItem={true}
                                                                            isBuyBst={true}
                                                                            hideQuickBid={
                                                                                props.hideQuickBid ||
                                                                                false
                                                                            }
                                                                        />
                                                                    </>
                                                                ))}
                                                            </div>
                                                        </LazyLoadComponent>
                                                    ))}
                                                </Slider>
                                            ) : (
                                                <Slider {...settings5}>
                                                    {endingProduct.map((item, index) => (
                                                        <LazyLoadComponent key={item?.id || index}>
                                                            <div
                                                                className={'liquidationBuyCard'}
                                                                key={`gl-${index}`}
                                                            >
                                                                {' '}
                                                                {console.log(item, 'item')}
                                                                <>
                                                                    <LotProduct
                                                                        data={item}
                                                                        lotImages={item?.lotImages}
                                                                        link={`/gallery/product-view/${item?.id}`}
                                                                        handleClick={() =>
                                                                            redirectAuction(
                                                                                `search/product-buyer-auction/${item.id}?cat=&rat=&est=0`,
                                                                            )
                                                                        }
                                                                        timerTheme={
                                                                            props.timerTheme
                                                                        }
                                                                        type={props.type || ''}
                                                                        cardTheme={props.cardTheme}
                                                                        noTimer={props.noTimer}
                                                                        getAllProducts={
                                                                            getAllSearchProducts
                                                                        }
                                                                        setViewProduct={
                                                                            setEndingProduct
                                                                        }
                                                                        viewProduct={endingProduct}
                                                                        audio={props.audio}
                                                                        productViewLink={`/product/${item?.id}?cat=`}
                                                                        bidStatus="true"
                                                                        fromComponent="home"
                                                                        timerIcon={true}
                                                                        card_theme="lotsauction"
                                                                        noBuyNow={false}
                                                                        flashCard={false}
                                                                        endingItem={true}
                                                                        hideQuickBid={
                                                                            props.hideQuickBid ||
                                                                            false
                                                                        }
                                                                    />
                                                                </>
                                                            </div>
                                                        </LazyLoadComponent>
                                                    ))}
                                                </Slider>
                                            )}
                                        </div>
                                    </>
                                </div>
                            ) : null}
                        </div>
                    )}
                    {isVarifiedGfTheme && !isBargainsProject && !isBuyBestProject && (
                        <div className="customContainer auctionListCnt">
                            {lotsPageLoading ? (
                                <Loaders
                                    name="product_grid_view"
                                    isLoading={lotsPageLoading}
                                    loop={4}
                                />
                            ) : endingProduct.length > 0 ? (
                                <div className="search-wrapper">
                                    <h2
                                        className="auctionListTitle text-capitalize"
                                        style={{ 'text-transform': 'capitalize' }}
                                    >
                                        {endingProduct[0].auction_city},{' '}
                                        <span className="text-uppercase">
                                            {isBuyBestProject
                                                ? 'VA'
                                                : endingProduct[0].auction_state.substring(0, 2)}
                                        </span>{' '}
                                        Auctions Closing Soon
                                    </h2>

                                    <>
                                        <div
                                            onClick={() => {
                                                handleEndingViewAllClick(
                                                    endingProduct[0].lotof,
                                                    endingProduct[0].auctionTitle,
                                                )
                                            }}
                                            className="viewAll"
                                        >
                                            View All
                                        </div>
                                        <div className="gridContainer liquidationAuctions featuredLots">
                                            <Slider {...settings5}>
                                                {endingProduct.map((item, index) => (
                                                    <LazyLoadComponent key={item?.id || index}>
                                                        <div
                                                            className={'liquidationBuyCard'}
                                                            key={`gl-${index}`}
                                                        >
                                                            <>
                                                                <LotProduct
                                                                    data={item}
                                                                    lotImages={item?.lotImages}
                                                                    link={`/gallery/product-view/${item?.id}`}
                                                                    handleClick={() =>
                                                                        redirectAuction(
                                                                            `search/product-buyer-auction/${item.id}?cat=&rat=&est=0`,
                                                                        )
                                                                    }
                                                                    timerTheme={props.timerTheme}
                                                                    type={props.type || ''}
                                                                    cardTheme={props.cardTheme}
                                                                    noTimer={props.noTimer}
                                                                    getAllProducts={
                                                                        getAllSearchProducts
                                                                    }
                                                                    setViewProduct={
                                                                        setEndingProduct
                                                                    }
                                                                    viewProduct={endingProduct}
                                                                    audio={props.audio}
                                                                    productViewLink={`/product/${item?.id}?cat=`}
                                                                    bidStatus="true"
                                                                    fromComponent="home"
                                                                    timerIcon={true}
                                                                    card_theme="lotsauction"
                                                                    noBuyNow={false}
                                                                    flashCard={false}
                                                                    endingItem={true}
                                                                    hideQuickBid={
                                                                        props.hideQuickBid || false
                                                                    }
                                                                />
                                                            </>
                                                        </div>
                                                    </LazyLoadComponent>
                                                ))}
                                            </Slider>
                                        </div>
                                    </>
                                </div>
                            ) : null}
                        </div>
                    )}
                    {isVarifiedGfTheme && (
                        <div className="customContainer auctionListCnt">
                            {lotsPageLoading ? (
                                <Loaders
                                    name="product_grid_view"
                                    isLoading={lotsPageLoading}
                                    loop={4}
                                />
                            ) : activeAuctions.length > 0 ? (
                                <div className="search-wrapper">
                                    <h2 className="auctionListTitle">
                                        {!isBargainsProject ? 'Live' : 'Current'} Auctions
                                    </h2>
                                    <div
                                        className="viewAll"
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                'search?q=&cat=&est=0&rat=&view=0&sort=17&slimit=50&title=ViewAll',
                                            )
                                        }
                                    >
                                        View All
                                    </div>

                                    {displayedAuctions.length > 0 ? (
                                        <div className="search-wrapper">
                                            {displayedAuctions.map((auction, index) => {
                                                const detailsUrl = `search?q=&cat=&est=0&rat=&view=0&sort=17&slimit=50&lotof=${
                                                    auction.id
                                                }&title=${encodeURIComponent(
                                                    auction.title,
                                                )}&auction=1`

                                                return (
                                                    <MultisellerListCard
                                                        key={auction.id} // stable key
                                                        data={auction}
                                                        details={detailsUrl}
                                                        card_theme="lotsauction"
                                                        endingHomeList
                                                        handleLotClick={auction.id}
                                                        auctionIndex={index}
                                                    />
                                                )
                                            })}
                                        </div>
                                    ) : (
                                        <div className="card card-body text-center">
                                            No items Found!
                                        </div>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    )}
                    {isVarifiedGfTheme && (
                        <>
                            {upcomingHome.length > 0 ? (
                                <div className="customContainer auctionListCnt">
                                    {lotsPageLoading ? (
                                        <Loaders
                                            name="product_grid_view"
                                            isLoading={lotsPageLoading}
                                            loop={4}
                                        />
                                    ) : (
                                        <div className="search-wrapper">
                                            <h2 className="auctionListTitle">
                                                {!isBargainsProject
                                                    ? 'UPCOMING Deals / SPECIAL EVENTS'
                                                    : 'Upcoming Auctions'}
                                            </h2>
                                            <div className="search-wrapper">
                                                {upcomingHome.map((data) => {
                                                    const detailsUrl = `search?q=&cat=&est=0&rat=&view=0&sort=17&slimit=50&lotof=${data.id}&title=${data.title}&auction=1`
                                                    return (
                                                        <MultisellerListCard
                                                            data={data}
                                                            key={data.id}
                                                            details={detailsUrl}
                                                            card_theme="lotsauction"
                                                            upComingHomeList
                                                            handleLotClick={data.id}
                                                        />
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : null}
                        </>
                    )}
                    {!isVarifiedGfTheme && (
                        <div className="container auctionListCnt">
                            {global?.pluginConfiguration?.advertisement?.enable == 1 && (
                                <div className="siteAds adsHome">
                                    {isMobile
                                        ? homeAds?.mobHomeTop[activeHomeAdsIndex?.mobHomeTop] || (
                                              <span>No mobile ad available</span>
                                          )
                                        : homeAds?.deskHomeTop[activeHomeAdsIndex?.deskHomeTop] || (
                                              <span>No desktop ad available</span>
                                          )}
                                </div>
                            )}
                            <div className="we-at-wrap p-0 m-0">
                                <div className="">
                                    <h2 className="wc-head">Choose the Location</h2>
                                    <div className="row">
                                        <div className="col-sm-6 col-md-6">
                                            <div className="we-at-card">
                                                <img
                                                    src="/lots-images/dallas.png"
                                                    alt=""
                                                    className="we-at-card-img"
                                                />
                                                <div className="loc">
                                                    <h4 className="we-at-card-head">
                                                        Dallas, Texas
                                                    </h4>
                                                    <p className="we-at-card-descp">
                                                        2832 Anode Ln, Dallas, TX
                                                    </p>
                                                    <p className="we-at-card-descp">
                                                        <strong>
                                                            {product_item.filter(
                                                                (val) =>
                                                                    val.name ==
                                                                    productLocalState
                                                                        .globalLocations[1],
                                                            ).length > 0
                                                                ? product_item.filter(
                                                                      (val) =>
                                                                          val.name ==
                                                                          productLocalState
                                                                              .globalLocations[1],
                                                                  )[0].count
                                                                : 0}{' '}
                                                            Items
                                                        </strong>
                                                    </p>
                                                    <PrimaryButton
                                                        label="Explore"
                                                        disabled={Loading}
                                                        type="button"
                                                        onClick={() =>
                                                            handleLocationChange(
                                                                productLocalState
                                                                    .globalLocations[1],
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-6">
                                            <div className="we-at-card">
                                                <img
                                                    src="/lots-images/denton.png"
                                                    alt=""
                                                    className="we-at-card-img"
                                                />
                                                <div className="loc">
                                                    <h4 className="we-at-card-head">
                                                        Denton, Texas
                                                    </h4>
                                                    <p className="we-at-card-descp">
                                                        Denton 4801 W University Dr Suite 104,
                                                        Denton, TX
                                                    </p>
                                                    <p className="we-at-card-descp">
                                                        <strong>
                                                            {product_item.filter(
                                                                (val) =>
                                                                    val.name ==
                                                                    productLocalState
                                                                        .globalLocations[2],
                                                            ).length > 0
                                                                ? product_item.filter(
                                                                      (val) =>
                                                                          val.name ==
                                                                          productLocalState
                                                                              .globalLocations[2],
                                                                  )[0].count
                                                                : 0}{' '}
                                                            Items
                                                        </strong>
                                                    </p>
                                                    <PrimaryButton
                                                        label="Explore"
                                                        disabled={Loading}
                                                        type="button"
                                                        onClick={() =>
                                                            handleLocationChange(
                                                                productLocalState
                                                                    .globalLocations[2],
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="shop-by-categories">
                                <h2 className="auctionListTitle">Shop By Category</h2>
                                {filterValues.length > 0 && (
                                    <Slider {...settings1}>
                                        {filterValues
                                            .filter(
                                                (data) =>
                                                    data?.name?.toLowerCase()?.trim() !== 'adult',
                                            )
                                            .map((data, index) => (
                                                <Link
                                                    to={
                                                        data?.category_id
                                                            ? `/search?q=&cat=${data.category_id}&est=0&rat=&view=0&sort=17&slimit=50`
                                                            : '/search'
                                                    }
                                                    key={index}
                                                >
                                                    <div className="sc-card" key={index}>
                                                        <div className="sc-img-box">
                                                            <img
                                                                src={
                                                                    data.cat_image
                                                                        ? process.env
                                                                              .REACT_APP_PRODUCT_IMAGE_URL +
                                                                          data.cat_image
                                                                        : process.env
                                                                              .REACT_APP_AUCTION_IMAGE_URL +
                                                                          global?.storeDetails?.logo
                                                                }
                                                                data-src="image.jpg"
                                                                onError={(e) => {
                                                                    e.target.src =
                                                                        '/lots-images/Logo.png'
                                                                }}
                                                                alt={data.name}
                                                            />
                                                        </div>

                                                        <p className="sc-label">{`${data.name} (${data.product_cnt})`}</p>
                                                    </div>
                                                </Link>
                                            ))}
                                    </Slider>
                                )}
                            </div>
                        </div>
                    )}
                    {!isVarifiedGfTheme && (
                        <>
                            {viewProduct.length > 0 && (
                                <div className="container auctionListCnt">
                                    <div>
                                        {lotsPageLoading ? (
                                            <Loaders
                                                name="product_grid_view"
                                                isLoading={lotsPageLoading}
                                                loop={4}
                                            />
                                        ) : (
                                            <div className="search-wrapper">
                                                <h2 className="auctionListTitle">Featured Lots</h2>
                                                {viewProduct.length > 0 ? (
                                                    <>
                                                        <div className="gridContainer liquidationAuctions featuredLots">
                                                            <Slider {...settings3}>
                                                                {viewProduct.map((item, index) => (
                                                                    <LazyLoadComponent
                                                                        key={item.id || index}
                                                                    >
                                                                        <div
                                                                            className={
                                                                                'liquidationBuyCard'
                                                                            }
                                                                            key={`gl-${index}`}
                                                                        >
                                                                            <>
                                                                                <LotProduct
                                                                                    data={item}
                                                                                    lotImages={
                                                                                        item.lotImages
                                                                                    }
                                                                                    link={`/gallery/product-view/${item.id}`}
                                                                                    handleClick={() =>
                                                                                        redirectAuction(
                                                                                            `product/${id}?cat=`,
                                                                                        )
                                                                                    }
                                                                                    timerTheme={
                                                                                        props.timerTheme
                                                                                    }
                                                                                    type={
                                                                                        props.type
                                                                                            ? props.type
                                                                                            : ''
                                                                                    }
                                                                                    noTimer={
                                                                                        props.noTimer
                                                                                    }
                                                                                    getAllProducts={
                                                                                        getAllSearchProducts
                                                                                    }
                                                                                    setViewProduct={
                                                                                        setViewProduct
                                                                                    }
                                                                                    viewProduct={
                                                                                        viewProduct
                                                                                    }
                                                                                    audio={
                                                                                        props.audio
                                                                                    }
                                                                                    productViewLink={`/product/${item.id}?cat=`}
                                                                                    bidStatus="true"
                                                                                    timerIcon={true}
                                                                                    hideQuickBid={
                                                                                        props.hideQuickBid
                                                                                            ? props.hideQuickBid
                                                                                            : false
                                                                                    }
                                                                                    card_theme="lotsauction"
                                                                                />
                                                                            </>
                                                                        </div>
                                                                    </LazyLoadComponent>
                                                                ))}
                                                            </Slider>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="card card-body text-center">
                                                        No items Found!
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {!isVarifiedGfTheme && (
                        <div className="container auctionListCnt">
                            {productLocalState.globalLocation == 'All' ? (
                                <>
                                    <div>
                                        {activeHomeLoading ? (
                                            <Loaders
                                                name="product_grid_view"
                                                isLoading={activeHomeLoading}
                                                loop={5}
                                            />
                                        ) : (
                                            <div className="search-wrapper">
                                                <h2 className="auctionListTitle">
                                                    {isTabletOrMobile &&
                                                    global?.storeConfigration
                                                        ?.auction_close_soon_mobile?.value
                                                        ? 'Current Auctions'
                                                        : `Featured Auctions in ${productLocalState.globalLocations[1]}`}
                                                </h2>
                                                <div className="home-fa-filters">
                                                    <ul>
                                                        {filterDateList.filter(
                                                            (val) =>
                                                                val.city ===
                                                                productLocalState
                                                                    .globalLocations[1],
                                                        ).length > 0 ? (
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        filterDate == null
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange('all')
                                                                    }
                                                                >
                                                                    All
                                                                </Button>
                                                            </li>
                                                        ) : null}
                                                        {filterDateList.filter(
                                                            (val) =>
                                                                val.city ===
                                                                productLocalState
                                                                    .globalLocations[1],
                                                        ).length > 0 ? (
                                                            filterDateList
                                                                .filter(
                                                                    (val) =>
                                                                        val.city ===
                                                                        productLocalState
                                                                            .globalLocations[1],
                                                                )
                                                                .map((data, index) => (
                                                                    <li key={index}>
                                                                        <Button
                                                                            className={
                                                                                filterDate ==
                                                                                moment(
                                                                                    data.format_date,
                                                                                ).format(
                                                                                    'YYYY-MM-DD',
                                                                                )
                                                                                    ? 'active'
                                                                                    : 'dateFilter'
                                                                            }
                                                                            onClick={() =>
                                                                                handleDateChange(
                                                                                    moment(
                                                                                        data.format_date,
                                                                                    ).format(
                                                                                        'YYYY-MM-DD',
                                                                                    ),
                                                                                )
                                                                            }
                                                                        >
                                                                            {moment(
                                                                                data.format_date,
                                                                            ).format(
                                                                                'MMMM D (ddd)',
                                                                            )}
                                                                        </Button>
                                                                    </li>
                                                                ))
                                                        ) : (
                                                            <></>
                                                        )}

                                                        {auctionSearch.between_date_io != 'all' ? (
                                                            <li>
                                                                <KeyboardDatePicker
                                                                    margin="0"
                                                                    id="fa-auction-date"
                                                                    inputVariant="outlined"
                                                                    label=""
                                                                    format="MMMM D (ddd)"
                                                                    className={`selectDate ${'customDatepicker'}`}
                                                                    value={selectedDate}
                                                                    onChange={handleDateChange}
                                                                    placeholder="Select Date"
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change date',
                                                                    }}
                                                                    keyboardIcon={
                                                                        <>
                                                                            Select Date
                                                                            <span className="material-icons-outlined">
                                                                                arrow_drop_down
                                                                            </span>
                                                                        </>
                                                                    }
                                                                />
                                                            </li>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </ul>
                                                    {!isMobile &&
                                                        (filterDateList.filter(
                                                            (val) =>
                                                                val.city ===
                                                                productLocalState
                                                                    .globalLocations[1],
                                                        ).length > 0 ? (
                                                            <Button
                                                                className="viewAll"
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        `auctions`,
                                                                    )
                                                                }
                                                            >
                                                                View All
                                                            </Button>
                                                        ) : null)}
                                                </div>
                                                {activeAuctions.filter(
                                                    (val) =>
                                                        val.city ===
                                                        productLocalState.globalLocations[1],
                                                ).length > 0 ? (
                                                    <>
                                                        <div className="gridContainer liquidationAuctions">
                                                            <Slider {...settings2}>
                                                                {activeAuctions
                                                                    .filter(
                                                                        (val) =>
                                                                            val.city ===
                                                                            productLocalState
                                                                                .globalLocations[1],
                                                                    )
                                                                    .map((data, index) => (
                                                                        <LotsGridAuction
                                                                            key={index}
                                                                            data={data}
                                                                            details={`search/product-buyer-auction/${data.id}?cat=&rat=&est=0`}
                                                                            timerTheme="multiseller"
                                                                            theme="multiseller"
                                                                            openCategory={
                                                                                handleCategory
                                                                            }
                                                                        />
                                                                    ))}
                                                            </Slider>
                                                        </div>
                                                        {isMobile && (
                                                            <div className="home-fa-filters">
                                                                <Button
                                                                    className="viewAll"
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            `auctions`,
                                                                        )
                                                                    }
                                                                >
                                                                    View All
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="card card-body text-center">
                                                        No items Found!
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div>
                                        <>
                                            {activeHomeLoading ? (
                                                <Loaders
                                                    name="product_grid_view"
                                                    isLoading={activeHomeLoading}
                                                    loop={5}
                                                />
                                            ) : (
                                                <div className="search-wrapper">
                                                    <h2 className="auctionListTitle">
                                                        {isTabletOrMobile &&
                                                        global?.storeConfigration
                                                            ?.auction_close_soon_mobile?.value
                                                            ? 'Current Auctions'
                                                            : `Featured Auctions in ${productLocalState.globalLocations[2]}`}
                                                    </h2>
                                                    <div className="home-fa-filters">
                                                        <ul>
                                                            {filterDateList2.filter(
                                                                (val) =>
                                                                    val.city ===
                                                                    productLocalState
                                                                        .globalLocations[2],
                                                            ).length > 0 ? (
                                                                <li>
                                                                    <Button
                                                                        className={
                                                                            filterDate2 == null
                                                                                ? 'active'
                                                                                : 'dateFilter'
                                                                        }
                                                                        onClick={() =>
                                                                            handleDateChange1('all')
                                                                        }
                                                                    >
                                                                        All
                                                                    </Button>
                                                                </li>
                                                            ) : null}
                                                            {filterDateList2.filter(
                                                                (val) =>
                                                                    val.city ===
                                                                    productLocalState
                                                                        .globalLocations[2],
                                                            ).length > 0 ? (
                                                                filterDateList2
                                                                    .filter(
                                                                        (val) =>
                                                                            val.city ===
                                                                            productLocalState
                                                                                .globalLocations[2],
                                                                    )
                                                                    .map((data, index) => (
                                                                        <li key={index}>
                                                                            <Button
                                                                                className={
                                                                                    filterDate2 ==
                                                                                    moment(
                                                                                        data.format_date,
                                                                                    ).format(
                                                                                        'YYYY-MM-DD',
                                                                                    )
                                                                                        ? 'active'
                                                                                        : 'dateFilter'
                                                                                }
                                                                                onClick={() =>
                                                                                    handleDateChange1(
                                                                                        moment(
                                                                                            data.format_date,
                                                                                        ).format(
                                                                                            'YYYY-MM-DD',
                                                                                        ),
                                                                                    )
                                                                                }
                                                                            >
                                                                                {moment(
                                                                                    data.format_date,
                                                                                ).format(
                                                                                    'MMMM D (ddd)',
                                                                                )}
                                                                            </Button>
                                                                        </li>
                                                                    ))
                                                            ) : (
                                                                <></>
                                                            )}

                                                            {auctionSearch.between_date_io_new !=
                                                            'all' ? (
                                                                <li>
                                                                    <KeyboardDatePicker
                                                                        margin="0"
                                                                        id="fa-auction-date"
                                                                        inputVariant="outlined"
                                                                        label=""
                                                                        format="MMMM D (ddd)"
                                                                        className={`selectDate ${'customDatepicker'}`}
                                                                        value={selectedDate1}
                                                                        onChange={handleDateChange1}
                                                                        placeholder="Select Date"
                                                                        KeyboardButtonProps={{
                                                                            'aria-label':
                                                                                'change date',
                                                                        }}
                                                                        keyboardIcon={
                                                                            <>
                                                                                Select Date
                                                                                <span className="material-icons-outlined">
                                                                                    arrow_drop_down
                                                                                </span>
                                                                            </>
                                                                        }
                                                                    />
                                                                </li>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </ul>
                                                        {!isMobile &&
                                                            (filterDateList2.filter(
                                                                (val) =>
                                                                    val.city ===
                                                                    productLocalState
                                                                        .globalLocations[2],
                                                            ).length > 0 ? (
                                                                <Button
                                                                    className="viewAll"
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            `auctions`,
                                                                        )
                                                                    }
                                                                >
                                                                    View All
                                                                </Button>
                                                            ) : null)}
                                                    </div>
                                                    {activeAuctions1.filter(
                                                        (val) =>
                                                            val.city ===
                                                            productLocalState.globalLocations[2],
                                                    ).length > 0 ? (
                                                        <>
                                                            <div className="gridContainer liquidationAuctions">
                                                                <Slider {...settings2}>
                                                                    {activeAuctions1
                                                                        .filter(
                                                                            (val) =>
                                                                                val.city ===
                                                                                productLocalState
                                                                                    .globalLocations[2],
                                                                        )
                                                                        .map((data, index) => (
                                                                            <LotsGridAuction
                                                                                key={index}
                                                                                data={data}
                                                                                details={`search/product-buyer-auction/${data.id}?cat=&rat=&est=0`}
                                                                                timerTheme="multiseller"
                                                                                theme="multiseller"
                                                                                openCategory={
                                                                                    handleCategory
                                                                                }
                                                                            />
                                                                        ))}
                                                                </Slider>
                                                            </div>
                                                            {isMobile && (
                                                                <div className="home-fa-filters">
                                                                    <Button
                                                                        className="viewAll"
                                                                        onClick={() =>
                                                                            handleRedirectInternal(
                                                                                history,
                                                                                `auctions`,
                                                                            )
                                                                        }
                                                                    >
                                                                        View All
                                                                    </Button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="card card-body text-center">
                                                            No Items Found! ss
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    </div>
                                </>
                            ) : (
                                <div>
                                    {activeHomeLoading ? (
                                        <Loaders
                                            name="product_grid_view"
                                            isLoading={activeHomeLoading}
                                            loop={5}
                                        />
                                    ) : (
                                        <div className="search-wrapper">
                                            <h2 className="auctionListTitle">
                                                {isTabletOrMobile &&
                                                global?.storeConfigration?.auction_close_soon_mobile
                                                    ?.value
                                                    ? 'Current Auctions'
                                                    : `Featured Auctions in ${productLocalState.globalLocation}`}
                                            </h2>
                                            <div className="home-fa-filters">
                                                <ul>
                                                    <li>
                                                        <Button
                                                            className={
                                                                auctionSearch.between_date_io ==
                                                                undefined
                                                                    ? 'active'
                                                                    : 'dateFilter'
                                                            }
                                                            onClick={() => handleDateChange('all')}
                                                        >
                                                            All
                                                        </Button>
                                                    </li>

                                                    {filterDateList.length > 0 ? (
                                                        filterDateList.map((data, index) => (
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        auctionSearch.between_date_io ==
                                                                        moment(
                                                                            data.format_date,
                                                                        ).format('YYYY-MM-DD')
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange(
                                                                            moment(
                                                                                data.format_date,
                                                                            ).format('YYYY-MM-DD'),
                                                                        )
                                                                    }
                                                                >
                                                                    {moment(
                                                                        data.format_date,
                                                                    ).format('MMMM D (ddd)')}
                                                                </Button>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <>
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        auctionSearch.between_date_io ==
                                                                        moment().format(
                                                                            'YYYY-MM-DD',
                                                                        )
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange(
                                                                            moment().format(
                                                                                'YYYY-MM-DD',
                                                                            ),
                                                                        )
                                                                    }
                                                                >
                                                                    {moment().format(
                                                                        'MMMM D (ddd)',
                                                                    )}
                                                                </Button>
                                                            </li>
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        auctionSearch.between_date_io ==
                                                                        moment()
                                                                            .add(1, 'days')
                                                                            .format('YYYY-MM-DD')
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange(
                                                                            moment()
                                                                                .add(1, 'days')
                                                                                .format(
                                                                                    'YYYY-MM-DD',
                                                                                ),
                                                                        )
                                                                    }
                                                                >
                                                                    {moment()
                                                                        .add(1, 'days')
                                                                        .format('MMMM D (ddd)')}
                                                                </Button>
                                                            </li>
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        auctionSearch.between_date_io ==
                                                                        moment()
                                                                            .add(2, 'days')
                                                                            .format('YYYY-MM-DD')
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange(
                                                                            moment()
                                                                                .add(2, 'days')
                                                                                .format(
                                                                                    'YYYY-MM-DD',
                                                                                ),
                                                                        )
                                                                    }
                                                                >
                                                                    {moment()
                                                                        .add(2, 'days')
                                                                        .format('MMMM D (ddd)')}
                                                                </Button>
                                                            </li>
                                                            <li>
                                                                <Button
                                                                    className={
                                                                        auctionSearch.between_date_io ==
                                                                        moment()
                                                                            .add(3, 'days')
                                                                            .format('YYYY-MM-DD')
                                                                            ? 'active'
                                                                            : 'dateFilter'
                                                                    }
                                                                    onClick={() =>
                                                                        handleDateChange(
                                                                            moment()
                                                                                .add(3, 'days')
                                                                                .format(
                                                                                    'YYYY-MM-DD',
                                                                                ),
                                                                        )
                                                                    }
                                                                >
                                                                    {moment()
                                                                        .add(3, 'days')
                                                                        .format('MMMM D (ddd)')}
                                                                </Button>
                                                            </li>
                                                        </>
                                                    )}

                                                    {auctionSearch.between_date_io != 'all' ? (
                                                        <li>
                                                            <KeyboardDatePicker
                                                                margin="0"
                                                                id="fa-auction-date"
                                                                inputVariant="outlined"
                                                                label=""
                                                                format="MMMM D (ddd)"
                                                                className={`selectDate
                                                            ${'customDatepicker'}`}
                                                                value={selectedDate}
                                                                onChange={handleDateChange}
                                                                placeholder="Select Date"
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                keyboardIcon={
                                                                    <>
                                                                        Select Date
                                                                        <span className="material-icons-outlined">
                                                                            arrow_drop_down
                                                                        </span>
                                                                    </>
                                                                }
                                                            />
                                                        </li>
                                                    ) : (
                                                        ''
                                                    )}
                                                </ul>
                                                <Button
                                                    className="viewAll"
                                                    onClick={() =>
                                                        handleRedirectInternal(history, `auctions`)
                                                    }
                                                >
                                                    View All
                                                </Button>
                                            </div>

                                            <div className="gridContainer liquidationAuctions">
                                                {activeAuctions.length > 0 ? (
                                                    <Slider {...settings2}>
                                                        {activeAuctions.map((data, index) => (
                                                            <LotsGridAuction
                                                                key={index}
                                                                data={data}
                                                                details={`search/product-buyer-auction/${data.id}?cat=&rat=&est=0`}
                                                                timerTheme="multiseller"
                                                                theme="multiseller"
                                                                openCategory={handleCategory}
                                                            />
                                                        ))}
                                                    </Slider>
                                                ) : (
                                                    <div className="card card-body text-center">
                                                        No Items Found!
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {!viewClosedAuction.length &&
                                !buyNowProduct.length &&
                                !viewProduct.length &&
                                !activeAuctions.length && (
                                    <div className="noContent">
                                        <img src="/assets/svg/noContent.svg" alt="No Content" />
                                        <h3>We are getting our inventory ready.</h3>
                                        <h3>Please visit back soon!</h3>
                                    </div>
                                )}

                            {global?.pluginConfiguration?.advertisement?.enable === 1 && (
                                <div className="siteAds adsHome">
                                    {isMobile
                                        ? homeAds?.mobHomeBottom?.[
                                              activeHomeAdsIndex?.mobHomeBottom
                                          ] ?? <span>No mobile ad</span>
                                        : homeAds?.deskHomeBottom?.[
                                              activeHomeAdsIndex?.deskHomeBottom
                                          ] ?? <span>No desktop ad</span>}
                                </div>
                            )}
                        </div>
                    )}
                    {isVarifiedGfTheme && !isBargainsProject && (
                        <>
                            <div className="customContainer auctionListCnt">
                                {lotsPageLoading ? (
                                    <Loaders
                                        name="product_grid_view"
                                        isLoading={lotsPageLoading}
                                        loop={4}
                                    />
                                ) : viewProduct.length > 0 ? (
                                    <div className="search-wrapper">
                                        <h2 className="auctionListTitle">Flash Deals</h2>

                                        <>
                                            <div onClick={handleViewAllClick} className="viewAll">
                                                View All
                                            </div>
                                            <div className="gridContainer liquidationAuctions featuredLots flashLots">
                                                <Slider {...settings6}>
                                                    {viewProduct.map((item, index) => (
                                                        <LazyLoadComponent key={index}>
                                                            <div
                                                                className={`liquidationBuyCard }`}
                                                                key={`gl-${index}`}
                                                            >
                                                                <>
                                                                    <LotProduct
                                                                        data={item}
                                                                        lotImages={item?.lotImages}
                                                                        link={`/gallery/product-view/${item?.id}`}
                                                                        handleClick={() =>
                                                                            redirectAuction(
                                                                                `search/product-buyer-auction/${data.id}?cat=&rat=&est=0`,
                                                                            )
                                                                        }
                                                                        timerTheme={
                                                                            props.timerTheme
                                                                        }
                                                                        type={
                                                                            props.type
                                                                                ? props.type
                                                                                : ''
                                                                        }
                                                                        cardTheme={props.cardTheme}
                                                                        noTimer={props.noTimer}
                                                                        getAllProducts={
                                                                            getAllSearchProducts
                                                                        }
                                                                        setViewProduct={
                                                                            setViewProduct
                                                                        }
                                                                        viewProduct={viewProduct}
                                                                        audio={props.audio}
                                                                        productViewLink={`/product/${item?.id}?cat=`}
                                                                        bidStatus="true"
                                                                        timerIcon={true}
                                                                        card_theme="lotsauction"
                                                                        noBuyNow={false}
                                                                        flashCard={true}
                                                                        isBuyBst={true}
                                                                        hideQuickBid={
                                                                            props.hideQuickBid
                                                                                ? props.hideQuickBid
                                                                                : false
                                                                        }
                                                                    />
                                                                </>
                                                            </div>
                                                        </LazyLoadComponent>
                                                    ))}
                                                </Slider>
                                            </div>
                                        </>
                                    </div>
                                ) : null}
                            </div>
                        </>
                    )}
                    {isVarifiedGfTheme && !isBargainsProject && (
                        <>
                            {isBuyBestProject ? (
                                <section className="how_it_works_buy py-4">
                                    <div className="customContainer">
                                        <div className="info-section">
                                            <div className="info-text text-center">
                                                <h2 className="text-center mb-3">How It Works</h2>
                                                <div className="info-details">
                                                    <div className="info-row">
                                                        <span className="info-title">
                                                            Win your item:
                                                        </span>
                                                        <span className="info-description">
                                                            Find what you love, place your bid, and
                                                            complete your payment when you win.
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-title">
                                                            Stay updated:
                                                        </span>
                                                        <span className="info-description">
                                                            ou’ll receive email and account
                                                            notifications as soon as your items are
                                                            ready for pickup.
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-title">Pick up:</span>
                                                        <span className="info-description">
                                                            Once notified, you have 5 days to pick
                                                            up your items—so be sure to pay
                                                            promptly.
                                                        </span>
                                                    </div>
                                                </div>

                                                <h2>What’s in it for you?</h2>
                                                <div className="benefits mb-4">
                                                    <div className="benefit-card">
                                                        <h4>
                                                            Less <br />
                                                            waiting
                                                        </h4>
                                                        <p>Items will be ready when you arrive.</p>
                                                    </div>
                                                    <div className="benefit-card">
                                                        <h4>
                                                            Clear <br />
                                                            communication
                                                        </h4>
                                                        <p>You’ll know when the items are ready.</p>
                                                    </div>
                                                    <div className="benefit-card">
                                                        <h4>
                                                            Improved <br />
                                                            efficiency
                                                        </h4>
                                                        <p>
                                                            A smoother pickup process for everyone.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="VideoBoxContainer">
                                                <div className="video-placeholder">
                                                    <video
                                                        ref={videoRef}
                                                        width={350}
                                                        height={320}
                                                        controls={isPlaying}
                                                        poster="/assets/images/BBL/thumbnail.jpeg"
                                                    >
                                                        <source
                                                            src={`${
                                                                isBuyBestProject
                                                                    ? '/assets/video/buyBestVideo.mp4'
                                                                    : '/assets/video/demoPrimebids.mp4'
                                                            }`}
                                                            type="video/mp4"
                                                        ></source>
                                                    </video>
                                                    {showOverlay && (
                                                        <div
                                                            onClick={
                                                                showOverlay
                                                                    ? handlePlayClick
                                                                    : undefined
                                                            }
                                                            style={{
                                                                position: 'absolute',
                                                                inset: 0,
                                                                // background: 'rgba(0,0,0,0.4)',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                cursor: 'pointer',
                                                                zIndex: 5,
                                                            }}
                                                        >
                                                            {/* Big Play Button */}
                                                            <div
                                                                style={{
                                                                    width: 80,
                                                                    height: 80,
                                                                    borderRadius: '50%',
                                                                    background:
                                                                        'rgba(255,255,255,0.8)',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        fontSize: 40,
                                                                        marginLeft: 5,
                                                                    }}
                                                                >
                                                                    ▶
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="video-placeholder">
                                                    <video
                                                        ref={video2Ref}
                                                        width={350}
                                                        height={320}
                                                        controls={is2Playing}
                                                        poster="/assets/images/BBL/videoreel.jpg"
                                                    >
                                                        <source
                                                            src="/assets/video/DMV.mp4"
                                                            type="video/mp4"
                                                        ></source>
                                                    </video>
                                                    {show2Overlay && (
                                                        <div
                                                            onClick={
                                                                show2Overlay
                                                                    ? handlePlay2Click
                                                                    : undefined
                                                            }
                                                            style={{
                                                                position: 'absolute',
                                                                inset: 0,
                                                                // background: 'rgba(0,0,0,0.4)',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                cursor: 'pointer',
                                                                zIndex: 5,
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: 80,
                                                                    height: 80,
                                                                    borderRadius: '50%',
                                                                    background:
                                                                        'rgba(255,255,255,0.8)',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        fontSize: 40,
                                                                        marginLeft: 5,
                                                                    }}
                                                                >
                                                                    ▶
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            ) : (
                                <div className="why-choose">
                                    <div className="customContainer">
                                        {isVarifiedGfTheme ? (
                                            <>
                                                <div className="googleReviewPoint mt-4">
                                                    <div className="customContainer pb-4 www">
                                                        <Reviews />
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <Slider {...settings4}>
                                                <div className="customerFeedback">
                                                    <div>
                                                        <img
                                                            src=""
                                                            alt="avathar"
                                                            width="40"
                                                            height="40"
                                                        />
                                                        <div>
                                                            <h5>Gahto</h5>
                                                            <span>3 month ago</span>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        Lorem Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum Lorem Ippsum Lorem Ippsum Lorem
                                                        Ippsum
                                                    </p>
                                                    <div>
                                                        <ul>
                                                            <li>
                                                                <span className="material-icons-outlined">
                                                                    star
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="material-icons-outlined">
                                                                    star
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="material-icons-outlined">
                                                                    star
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="material-icons-outlined">
                                                                    star
                                                                </span>
                                                            </li>
                                                        </ul>
                                                        <img
                                                            src=""
                                                            alt="Google"
                                                            width="40"
                                                            height="40"
                                                        />
                                                    </div>
                                                </div>
                                            </Slider>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <CategoryModal open={open2} lotof={lotof} handleClose={() => setOpen2(false)} />
            </Layout>
        </>
    )
}

export default Home
